<template>
  <Transition name="scroll-button-fade">
    <button
      v-if="props.show"
      class="sidd-scroll-to-bottom"
      @click="handleClick"
      :aria-label="props.ariaLabel"
      :title="props.title"
    >
      <ArrowDown :size="16" />
    </button>
  </Transition>
</template>

<script setup lang="ts">
import { ArrowDown } from 'lucide-vue-next'
import type { IScrollToBottomProps, IScrollToBottomEmits } from './types'

const props = withDefaults(defineProps<IScrollToBottomProps>(), {
  show: false,
  ariaLabel: 'Scroll to bottom',
  title: 'Scroll to bottom',
})

const emit = defineEmits<IScrollToBottomEmits>()

const handleClick = () => {
  emit('click')
}
</script>

<style scoped>
.sidd-scroll-to-bottom {
  position: absolute;
  bottom: 8px;
  right: 3%;
  transform: translateX(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: hsl(var(--primary));
  color: #ffffff;
  border: none;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.2s ease;
}

.sidd-scroll-to-bottom:hover {
  background: hsl(var(--primary) / 0.9);
  transform: translateX(-50%) scale(1.05);
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.sidd-scroll-to-bottom:active {
  transform: translateX(-50%) scale(0.95);
}

.sidd-scroll-to-bottom:focus-visible {
  outline: 2px solid hsl(var(--primary));
  outline-offset: 2px;
}

.scroll-button-fade-enter-active,
.scroll-button-fade-leave-active {
  transition: all 0.3s ease;
}

.scroll-button-fade-enter-from {
  opacity: 0;
  transform: translateX(-50%) translateY(10px);
}

.scroll-button-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(10px);
}

@media (prefers-reduced-motion: reduce) {
  .sidd-scroll-to-bottom {
    transition: none;
  }

  .scroll-button-fade-enter-active,
  .scroll-button-fade-leave-active {
    transition: none;
  }
}
</style>
